export default __webpack_public_path__ + "static/media/userPages.15e29260.jpg";